export const OSDnames = {
  state: {
    viewer: 'viewer',
    scale: 'scale',
    deskDimensions: 'deskDimensions'
  },
  mutations: {
    SET_DESK_DIMENSIONS: 'SET_DESK_DIMENSIONS',
    UPDATE_SCALE: 'UPDATE_SCALE'
  },
  actions: {
    createOpenSeaDragon: 'createOpenSeaDragon',
    destroyOpenSeaDragon: 'destroyOpenSeaDragon'
  },
  getters: {
    viewer: 'viewer',
    scale: 'scale',
    deskDimensions: 'deskDimensions'
  }
}

export default OSDnames
